import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonButton, IonContent, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonRadio, IonRadioGroup, IonSearchbar, IonSpinner, IonTitle, IonToolbar, ModalController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { LanguageModalStore } from './store/language-modal.store';
import { TranslationPipe } from '@raptor-fe/services';
import { CustomFilterPipe } from '@raptor-fe/core';

@Component({
    template: `    
       <ion-header>
          <ion-toolbar>
            <ion-title>
              {{ { feature: "Common", component: "Modal", label: "Change Language" } | translate }}
            </ion-title>        
            <ion-button
              (click)="close()"
              fill="outline"
              slot="start"
              size="small">
              {{ { feature: "Common", component: "Button", label: "Cancel" } | translate }}
            </ion-button>          
            <ion-button
              [disabled]="store.isLoading()"
              (click)="store.getTranslations(store.newLanguage())"
              fill="solid"
              slot="end"
              size="small">
              {{ { feature: "Common", component: "Button", label: "Save" } | translate }}
            </ion-button>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          @if(store.isLoading()){                        
              <ion-spinner class="m-4 block mx-auto" name="crescent"></ion-spinner>
          }
          @else{
            <ion-searchbar
              placeholder="{{ { feature: 'Common', component: 'Modal', label: 'Search Languages' } | translate }}"
              type="search"
              (ionInput)="store.updateSearchTerm($event.target.value!)"
            ></ion-searchbar>          
            <ion-list>
              @if(store.errorMessage()){
                <ion-item>
                  <ion-label color="danger">
                    {{ store.errorMessage() }}
                  </ion-label>
                </ion-item>
              }
              <ion-radio-group (ionChange)="store.updateNewLanguage($event.detail.value)" [value]="store.newLanguage().id">
                <ion-list-header>
                <ion-label>
                  {{ { feature: "Common", component: "Modal", label: "Available Languages" } | translate }}
                </ion-label>
                </ion-list-header>              
                @for (entry of store.languageList() | filter: store.filterTerm(); track entry) {
                  <ion-item>
                    <ion-radio [value]="entry.id">{{ entry.name }}</ion-radio>
                  </ion-item>
                }            
              </ion-radio-group>
            </ion-list>
          }
        </ion-content>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LanguageModalStore],
    imports: [IonButton, IonContent, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonRadio, IonRadioGroup, IonSearchbar, IonSpinner, IonTitle, IonToolbar, FormsModule, TranslationPipe, CustomFilterPipe],
})
export class LanguageModalComponent {
    private readonly modalController = inject(ModalController);
    protected readonly store = inject(LanguageModalStore);

    close(): void {
        this.modalController.dismiss(null, 'cancel');
    }
}
